import axios from 'axios';
import { jwtDecode } from 'jwt-decode'; // Correct the import to use named import

export const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    try {
      const backendUrl = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_BACKEND_URL
  : 'http://localhost:8080';
      const response = await axios.post(`${backendUrl}/refresh`, { refresh_token: refreshToken });
      localStorage.setItem('token', response.data.token);
      return response.data.token;
    } catch (error) {
      console.error('Failed to refresh token:', error);
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
      // Optionally, redirect to the login page
      window.location.href = '/login';
      throw error;
    }
  };
  
export const getAccessToken = async () => {
  const token = localStorage.getItem('token');
  if (!token) throw new Error('No token found');

  const tokenData = jwtDecode(token);
  const currentTime = Date.now() / 1000; // Current time in seconds

  if (tokenData.exp < currentTime) {
    // Token is expired, refresh it
    return await refreshAccessToken();
  }
  return token;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  const tokenData = jwtDecode(token);
  const currentTime = Date.now() / 1000;

  return tokenData.exp > currentTime;
};

// utils/auth.js
export const getCurrentUserId = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    console.log(decoded)
    return decoded.id || decoded.user_id;
  } catch {
    return null;
  }
};
